// src/pages/Industries.jsx
import React from "react";
import pipelinesImg from "../assets/plant1.png"; 
import fabricationImg from "../assets/Plant2.jpg";
import infrastructureImg from "../assets/plant3.jpg";
import oilGasImg from "../assets/plant4.jpg";
import power from "../assets/plant5.jpeg";
import aerospace from "../assets/plant6.png";
import ship from "../assets/plant7.png";
import { Helmet } from "react-helmet-async";




const industries = [
  {
    title: "Offshore & Onshore Pipelines",
    desc: "We provide precise NDT inspections for pipelines, ensuring structural integrity, leak detection, and compliance with international safety standards. Our ultrasonic and phased array testing methods detect even the smallest flaws before they become major issues.",
    img: pipelinesImg,
  },
  {
    title: "Marine & Shipbuilding",
    desc: "We inspect ships, hulls, and offshore platforms using NDT techniques to detect corrosion, cracks, and structural weaknesses, ensuring safety and regulatory compliance.",
    img: ship,
  },
  {
    title: "Engineering Fabrications",
    desc: "From structural steel to custom engineering components, our certified NDT team evaluates welds, joints, and materials using TOFD, PAUT, and UT techniques to guarantee superior quality and safety in your projects.",
    img: fabricationImg,
  },
  {
    title: "Industrial Infrastructure",
    desc: "We inspect bridges, industrial plants, and critical infrastructure to detect cracks, corrosion, and other structural issues. Our detailed reports help maintain operational safety and extend the life of your assets.",
    img: infrastructureImg,
  },
  {
    title: "Oil & Gas Industry",
    desc: "Our specialized NDT solutions support refineries, rigs, and storage tanks. Using advanced methods like Magnetic Particle Testing and Liquid Penetrant Testing, we ensure safety, reliability, and compliance with regulatory standards.",
    img: oilGasImg,
  },
  {
    title: "Power & Energy Sector",
    desc: "We provide inspection services for power plants, turbines, and energy infrastructure, detecting defects and ensuring operational efficiency and safety.",
    img: power,
  },
  {
    title: "Aerospace & Aviation",
    desc: "NDT inspections for aircraft components, engines, and structural assemblies to ensure airworthiness and compliance with international aviation standards.",
    img: aerospace,
  },
  
];

const Industries = () => {
  return (
    <>
    <Helmet>

  <title>
    Industries We Serve | Focus Inspection Technology | Oil Gas Shipyard Refinery Inspection
  </title>

  <meta
    name="description"
    content="
Focus Inspection Technology provides NDT inspection services for Oil & Gas, Shipyard, Refinery, Pipeline, Power Plant, Fabrication and Heavy Engineering industries including PAUT, TOFD, UT, RT, MT and PT testing worldwide.
"
  />

  <meta
    name="keywords"
    content="
Focus Inspection Technology industries,
NDT oil and gas,
shipyard inspection,
refinery inspection,
pipeline inspection,
power plant inspection,
fabrication inspection,
industrial ndt services,
PAUT TOFD industries,
inspection company industries,
ndt services worldwide
"
  />

  <link
    rel="canonical"
    href="https://focusinspectiontechnology.com/industries"
  />

  <meta
    property="og:title"
    content="Industries | Focus Inspection Technology"
  />

  <meta
    property="og:description"
    content="NDT inspection services for Oil & Gas, Shipyard, Refinery, Pipeline, Power Plant and Heavy Engineering industries."
  />

  <meta
    property="og:image"
    content="https://focusinspectiontechnology.com/images/excellence.jpeg"
  />

  <meta
    property="og:url"
    content="https://focusinspectiontechnology.com/industries"
  />

  <meta property="og:type" content="website" />

  <meta name="twitter:card" content="summary_large_image" />

  <meta
    name="twitter:title"
    content="Industries | Focus Inspection Technology"
  />

  <meta
    name="twitter:description"
    content="Inspection services for oil gas, refinery, shipyard, pipeline and power plant industries."
  />

  <meta
    name="twitter:image"
    content="https://focusinspectiontechnology.com/images/excellence.jpeg"
  />

</Helmet>
    <div className="w-full bg-gray-50">
      {/* Hero Section */}

<section className="relative w-full h-80 flex items-center justify-center mb-16 overflow-hidden">
  {/* Gradient Background */}
  <div className="absolute inset-0 bg-gradient-to-r from-gray-800 to-blue-900"></div>

  {/* Industrial Pattern Overlay */}
  <svg className="absolute inset-0 w-full h-full opacity-20 animate-pulse" xmlns="http://www.w3.org/2000/svg">
    {/* Hex grid pattern */}
    <defs>
      <pattern id="hexPatternServices" width="60" height="52" patternUnits="userSpaceOnUse" patternTransform="rotate(30)">
        <polygon points="30,0 60,15 60,45 30,60 0,45 0,15" stroke="white" strokeWidth="0.3" fill="none" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#hexPatternServices)" />

    {/* Diagonal lines */}
    <line x1="0" y1="0" x2="800" y2="800" stroke="white" strokeWidth="0.2" />
    <line x1="800" y1="0" x2="0" y2="800" stroke="white" strokeWidth="0.2" />

    {/* Gear-like circles */}
    <circle cx="150" cy="100" r="80" stroke="white" strokeWidth="0.5" fill="none" />
    <circle cx="600" cy="50" r="120" stroke="white" strokeWidth="0.5" fill="none" />
  </svg>

  {/* Hero Text */}
  <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
    <h1 className="text-4xl md:text-5xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-gray-300 via-white to-gray-400 drop-shadow-lg">
      Industries We Serve
    </h1>
    <p className="text-lg md:text-xl max-w-2xl mx-auto text-white">
      FOCUS Inspection Technology provides expert NDT solutions across multiple industries to ensure safety, quality, and reliability of critical assets.
    </p>
  </div>
</section>


      {/* Industries Grid */}
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {industries.map((industry, idx) => (
          <div
            key={idx}
            className="flex flex-col bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition"
          >
            {/* Image */}
            <div className="h-56 w-full overflow-hidden">
              <img
                src={industry.img}
                            loading="lazy"

                alt={industry.desc}
                className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
              />
            </div>

            {/* Text */}
            <div className="p-6 flex flex-col flex-grow">
              <h3 className="text-xl font-bold text-blue-700 mb-3">
                {industry.title}
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed flex-grow">
                {industry.desc}
              </p>
            </div>
          </div>
        ))}
      </section>
    </div>
    </>
  );
};

export default Industries;
